import { PAGE_EVENTS } from 'src/interfaces/enums';
import { DEFAULT_MESSAGE } from './constants';

const beforeUnloadListener = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  return (event.returnValue = DEFAULT_MESSAGE);
};

const onPageHasUnsavedChanges = () => {
  window.addEventListener(PAGE_EVENTS.BEFOREUNLOAD.toLowerCase(), beforeUnloadListener, { capture: true });
};

const onAllChangesSaved = () => {
  window.removeEventListener(PAGE_EVENTS.BEFOREUNLOAD.toLowerCase(), beforeUnloadListener, { capture: true });
};

export { onPageHasUnsavedChanges, onAllChangesSaved };
